/**
 * Sandbox Error Types
 */

export class SandboxError extends Error {
  constructor(message, type, location = null) {
    super(message)
    this.name = 'SandboxError'
    this.type = type // 'parse' | 'validate' | 'runtime' | 'timeout'
    this.location = location // { line, column }
  }
}

export class ParseError extends SandboxError {
  constructor(message, location) {
    super(message, 'parse', location)
    this.name = 'ParseError'
  }
}

export class ValidationError extends SandboxError {
  constructor(message, location) {
    super(message, 'validate', location)
    this.name = 'ValidationError'
  }
}

export class RuntimeError extends SandboxError {
  constructor(message, location) {
    super(message, 'runtime', location)
    this.name = 'RuntimeError'
  }
}

export class TimeoutError extends SandboxError {
  constructor(timeout) {
    super(`Execution timeout after ${timeout}ms`, 'timeout')
    this.name = 'TimeoutError'
  }
}

export class IterationLimitError extends SandboxError {
  constructor(limit) {
    super(`Maximum iterations exceeded (${limit})`, 'runtime')
    this.name = 'IterationLimitError'
  }
}
